import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./styles.css";
import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import About from "./components/About";
import Footer from "./components/Footer";
import Services from "./components/Services";
import Local from "./components/Local";
import Team from "./components/Team";
import Espaco from "./components/Espaco";
import Historia from "./components/Historia";
import Convenios from "./components/Convenios";

export default function App() {
  
  return (
    <div className="landing-container">
      
      <Banner />
      <Services />
      <Convenios />
      <About />      
      <Team />
      <Historia />      
      <Espaco />
      <Local />
      <Footer />
    </div>
  );
}
